import "./Home.scss"


const homePic = require('../../images/camera.jpg');
const arrowPic = require('../../images/arrow2.png')



const Home = () => {


    return (
        <div id="home" className='home'>

            <div className="home1">

                <div className="home2">

                    <p>specialize in delivering captivating video productions for global brands and agencies</p>
                    <img src={arrowPic} alt="arrow" />
                </div>
                <p className="home-desc">Visualize
                    Tomorrow
                    with Clipbait Media.</p>
            </div>

            <img className="homePic" src={homePic} alt="home" />





        </div>




    );
};


export default Home;